import {Injectable} from '@angular/core';
import {JwtPayload, jwtDecode} from 'jwt-decode';
import {SessionStorageService} from './session-storage.service';
import {StorageModule} from './storage.module';

@Injectable({
  providedIn: StorageModule,
})
export class SessionTokenManager {
  public constructor(private sessionStorage: SessionStorageService) {}

  /**
   * Retrieve an OIDC JWT from sessionStorage
   */
  public getToken(provider: string, securityProfileID: string): string | null {
    const key = this.generateKey('jwt', provider, securityProfileID);
    return this.sessionStorage.getItem(key);
  }

  /**
   * Retrieve a refresh token from sessionStorage
   */
  public getRefreshToken(
    provider: string,
    securityProfileID: string,
  ): string | null {
    const key = this.generateKey('refresh', provider, securityProfileID);
    return this.sessionStorage.getItem(key);
  }

  /**
   * Place an OIDC JWT into sessionStorage
   */
  public setToken(
    provider: string,
    securityProfileID: string,
    token: string,
  ): void {
    const key = this.generateKey('jwt', provider, securityProfileID);
    return this.sessionStorage.setItem(key, token);
  }

  /**
   * Place a refresh token into sessionStorage
   */
  public setRefreshToken(
    provider: string,
    securityProfileID: string,
    token: string,
  ): void {
    const key = this.generateKey('refresh', provider, securityProfileID);
    return this.sessionStorage.setItem(key, token);
  }

  /**
   * Decode a JWT token
   */
  public decodeToken(token: string): JwtPayload {
    return jwtDecode<JwtPayload>(token);
  }

  /**
   * Generate a session storageStorage key from params
   */
  public generateKey(
    type: 'refresh' | 'jwt',
    provider: string,
    securityProfileID: string,
  ): string {
    return [type, provider, securityProfileID].join(':');
  }
}
